module.exports = __webpack_public_path__ + "img/product-preview-67.8ac3b4f.png";